import React, { useEffect, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import '../css/mudService.css';

const MudService = () => {
    const underlineRef = useRef(null);

    useEffect(() => {
        const timer = setTimeout(() => {
            if (underlineRef.current) {
                underlineRef.current.classList.add('animate');
            }
        }, 50);

        return () => clearTimeout(timer);
    }, []);

    return (
        <>
            {/* Hero Section */}
            <div className="container-fluid about-bg d-flex align-items-end" style={{ minHeight: '85vh', padding: 0,    top: '-122px' }}>
            <div className="container about-content py-5">
                    <div className="row">
                        <div className="col-lg-8 col-md-10 col-12">
                            <h1 className="about-title display-4 fw-bold">Mud Services</h1>
                            <h2 className="about-subtitle h4">Petrochoice Integrated Services</h2>
                            <div className="about-underline mt-2" ref={underlineRef}></div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Mud Services Section */}
            <section className="py-5 bg-white">
                <div className="container">
                    <div className="row align-items-center g-5">

                        {/* Text Content */}
                        <div className="col-lg-6">
                            <h2 className="fw-bold mb-4" style={{ color: '#0c61c0' }}>
                                Complete Mud Engineering & Fluids Services
                            </h2>

                            <p className="mb-4 text-muted fs-5">
                                We provide expert water-based, oil-based, and completion fluids to ensure your operations stay efficient and trouble-free.
                            </p>

                            <div className="mb-4">
                                <h5 className="fw-semibold mb-3" style={{ color: '#0c61c0' }}>Technical Services</h5>
                                <ul className="list-unstyled ps-3">
                                    <li className="mb-2">
                                        <i className="bi bi-check-circle-fill me-2" style={{ color: '#0c61c0' }}></i>
                                        Drilling Fluids Materials
                                    </li>
                                    <li className="mb-2">
                                        <i className="bi bi-check-circle-fill me-2" style={{ color: '#0c61c0' }}></i>
                                        Drilling Fluids Engineering
                                    </li>
                                    <li className="mb-2">
                                        <i className="bi bi-check-circle-fill me-2" style={{ color: '#0c61c0' }}></i>
                                        Completion Fluids Engineering
                                    </li>
                                    <li className="mb-2">
                                        <i className="bi bi-check-circle-fill me-2" style={{ color: '#0c61c0' }}></i>
                                        In-House Tech Support
                                    </li>
                                    <li>
                                        <i className="bi bi-check-circle-fill me-2" style={{ color: '#0c61c0' }}></i>
                                        24/7 fluid delivery and responsive on-site support.
                                    </li>
                                </ul>
                            </div>

                            <div className="mb-4">
                                <h5 className="fw-semibold mb-3" style={{ color: '#0c61c0' }}>Fluids Services</h5>
                                <ul className="list-unstyled ps-3">
                                    <li className="mb-2"><i className="bi bi-droplet-fill me-2" style={{ color: '#0c61c0' }}></i>Water-Based Chemicals</li>
                                    <li className="mb-2"><i className="bi bi-droplet-fill me-2" style={{ color: '#0c61c0' }}></i>Oil-Based Chemicals</li>
                                    <li className="mb-2"><i className="bi bi-droplet-fill me-2" style={{ color: '#0c61c0' }}></i>Completion Fluids Chemicals</li>
                                    <li className="mb-2"><i className="bi bi-shield-lock-fill me-2" style={{ color: '#0c61c0' }}></i>Corrosion Inhibitors</li>
                                </ul>
                            </div>

                            <button className="btn rounded-pill px-4 py-2 fw-bold text-white" style={{ backgroundColor: '#0c61c0' }}>
                                <i className="bi bi-envelope-check-fill me-2"></i>Request a Quotation
                            </button>
                        </div>

                        {/* Image */}
                        <div className="col-lg-6 text-center">
                            <img
                                src="/assets/mud-service-image.jpg"
                                alt="Mud Service Bags"
                                className="img-fluid rounded-4 shadow"
                                style={{ maxHeight: '480px', objectFit: 'cover' }}
                            />
                        </div>
                    </div>
                </div>
            </section>

            {/* Multi-Item Carousel Section */}
            <section className="py-5 bg-light">
                <div className="container">
                    <h3 className="text-center fw-bold mb-5" style={{ color: '#0c61c0' }}>
                        Our Facilities & Operations
                    </h3>

                    <div id="mudMultiCarousel" className="carousel slide" data-bs-ride="carousel">
                        <div className="carousel-inner">

                            {/* Slide 1 */}
                            <div className="carousel-item active">
                                <div className="row">
                                    <div className="col-md-4">
                                        <img src="/assets/mud-gallery-1.jpg" className="d-block w-100 rounded shadow-sm" alt="Image 1" style={{ height: '280px', objectFit: 'cover' }} />
                                    </div>
                                    <div className="col-md-4">
                                        <img src="/assets/mud-gallery-2.jpg" className="d-block w-100 rounded shadow-sm" alt="Image 2" style={{ height: '280px', objectFit: 'cover' }} />
                                    </div>
                                    <div className="col-md-4">
                                        <img src="/assets/mud-gallery-3.jpg" className="d-block w-100 rounded shadow-sm" alt="Image 3" style={{ height: '280px', objectFit: 'cover' }} />
                                    </div>
                                </div>
                            </div>

                            {/* Slide 2 (next group of 3 images) */}
                            <div className="carousel-item">
                                <div className="row">
                                    <div className="col-md-4">
                                        <img src="/assets/mud-gallery-4.jpg" className="d-block w-100 rounded shadow-sm" alt="Image 4" style={{ height: '280px', objectFit: 'cover' }} />
                                    </div>
                                    <div className="col-md-4">
                                        <img src="/assets/mud-gallery-5.jpg" className="d-block w-100 rounded shadow-sm" alt="Image 5" style={{ height: '280px', objectFit: 'cover' }} />
                                    </div>
                                    <div className="col-md-4">
                                        <img src="/assets/mud-gallery-6.jpg" className="d-block w-100 rounded shadow-sm" alt="Image 6" style={{ height: '280px', objectFit: 'cover' }} />
                                    </div>
                                </div>
                            </div>

                            {/* You can continue adding more <div className="carousel-item"> if needed */}

                        </div>

                        {/* Carousel Controls */}
                        <button className="carousel-control-prev" type="button" data-bs-target="#mudMultiCarousel" data-bs-slide="prev">
                            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Previous</span>
                        </button>
                        <button className="carousel-control-next" type="button" data-bs-target="#mudMultiCarousel" data-bs-slide="next">
                            <span className="carousel-control-next-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Next</span>
                        </button>
                    </div>
                </div>
            </section>



        </>
    );
};

export default MudService;
